import React, { useState, useEffect, useRef, useMemo } from 'react'
import '../../../Assets/Css/EmpLeaveView.scss'
import '../../../Assets/Css/ViewEmployee.scss'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import UserAvatar from 'react-user-avatar';
import moment from 'moment';
import Table from '../../../Components/Table';
import { connect } from 'react-redux';
import { getLeaves, updateLeave } from '../../../Services/Leave/action';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../../Assets/ModulesLiist';
import FeaturesList from '../../../Assets/FeaturesList';
import { customStyle } from '../../../Components/Style';
import Select from "react-select";
import qs from "query-string";
import CustomCalendar from '../../../Components/CustomCalendar';
import { Spinner } from 'react-bootstrap';

const MultipleLeaveView = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id, employeeId } = useParams();
    const modalRef = useRef(null);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [checked, setChecked] = useState(false);
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [params, setParams] = useState({});
    const [selectedId, setSelectedId] = useState([]);
    const [inData, setInData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [clientData, setClientData] = useState({ projectstatus: null });
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);
    

    const permissions = useMemo(() => {
        return {
            canView: checkFeatureAccess({
                modules: props?.modules,
                features: props?.features,
                user: props?.user,
                ModuleName: ModulesList.Leaves,
                Featur_Name: FeaturesList.View,
            }),
            canEdit: checkFeatureAccess({
                modules: props?.modules,
                features: props?.features,
                user: props?.user,
                ModuleName: ModulesList.Leaves,
                Featur_Name: FeaturesList.Update,
            }),
            canApprove: checkFeatureAccess({
                modules: props?.modules,
                features: props?.features,
                user: props?.user,
                ModuleName: ModulesList.Leaves,
                Featur_Name: FeaturesList.Approve,
            }),
            canReject: checkFeatureAccess({
                modules: props?.modules,
                features: props?.features,
                user: props?.user,
                ModuleName: ModulesList.Leaves,
                Featur_Name: FeaturesList.Reject,
            }),
            canDelete: checkFeatureAccess({
                modules: props?.modules,
                features: props?.features,
                user: props?.user,
                ModuleName: ModulesList.Leaves,
                Featur_Name: FeaturesList.Delete,
            })
        };
    }, [props?.modules, props?.features, props?.user]);

    const { canView, canEdit, canApprove, canReject, canDelete } = permissions;
    
    useEffect(() => {
        const initializeData = async () => {
            try {
                if (location?.state?.data?.allData) {
                  
                    const allData = Object.values(location.state.data.allData);
                    setData(allData);
                } else if (id) {
                
                    await props?.getLeaves();
                    const singleLeave = props?.leave?.find(leave => leave.id == id);
                    if (singleLeave) {
                        setData([singleLeave]); 
                    }
                }
            } catch (error) {
                console.error("Error fetching leave:", error);
            } finally {
                setLoading(false);
            }
        };
        
        initializeData();
    }, [id, location?.state, props?.leave]);
    
  
    const computedValues = useMemo(() => {
        if (!data) return { isMultipleLeaves: false, leaveData: null };
        
        const isMultipleLeaves = Array.isArray(data) && data.length > 1;
        const leaveData = Array.isArray(data) ? data[0] : data;
        
        return { isMultipleLeaves, leaveData };
    }, [data]);
    
    const { isMultipleLeaves, leaveData } = computedValues;
    
  
    const ProjectStatus = useMemo(() => [
        { value: "Approved", label: "Approved", color: 'rgb(0, 194, 146)' },
        { value: "Rejected", label: "Rejected", color: '#D21010' },
        { value: "Pending", label: "Pending", color: '#f6b000' },
    ], []);


    const header = useMemo(() => [
        { field: "checkbox" },
        { field: "Employee" },
        { field: "Start Date" },
        { field: "End Date" },
        { field: "Duration" },
        { field: "Leave Status" },
        { field: "Leave Type" },
        { field: "Action" },
    ], []);

    const footer = true;
    const count = inData.length;


    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props?.getLeaves();
        } catch (error) {
            console.error("Error fetching leaves:", error);
        }
    };

 
    const mappedTableData = useMemo(() => {
        if (!data || !Array.isArray(data)) return [];
        
        return data.map((item) => ({
            checkbox: {
                value: item?.id,
                type: "checkbox",
            },
            Employee: {
                value: item?.user?.name,
                value2: item?.user?.designation?.name,
                src: item?.user?.profile_pic?.data || "",
                type: "client"
            },
            "Start Date": {
                value: moment(item?.start_date?.split(" ")?.[0] || item?.leave_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                type: "date"
            },
            "End Date": {
                value: moment(item?.end_date?.split(" ")?.[0] || item?.leave_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                type: "date"
            },
            Duration: {
                value: (item?.firstHalf && item?.secondHalf) ? 'Single' : "Half Day",
                value2: (item?.firstHalf && item?.secondHalf) ? "" : item?.firstHalf ? 'First Half' : 'Second Half',
                type: "text"
            },
            "Leave Status": {
                value: item?.status,
                type: "leaveStatus"
            },
            "Leave Type": {
                value: (item?.casual > 0 && item?.unpaid > 0) ? "Casual/Unpaid" : item?.unpaid > 0 ? "Unpaid" : "Casual",
                value2: (item?.firstHalf && item?.secondHalf) ? "" : item?.firstHalf ? 'First Half' : 'Second Half',
                type: "leaveType"
            },
            Action: {
                value: location.pathname.includes(`/employees/view/${employeeId}/leave/edit`) ? `/employees/view/${employeeId}/leave/edit` : '/leave/empleave/edit/',
                value2: location.pathname.includes(`/employees/view/${employeeId}/leave/view`) ? `/employees/view/${employeeId}/leave/view` : `/leave/empleave/view/${item?.id}`,
                value3: item?.id,
                showIsEdit: canEdit && item?.status === "Pending",
                showIsApprove: canApprove && item?.status !== "Approved",
                showIsReject: canReject && item?.status !== "Rejected",
                value4: "Approve",
                value5: "Reject",
                type: "action",
            },
            allData: item
        }));
    }, [data, canEdit, canApprove, canReject, employeeId, location.pathname]);


    useEffect(() => {
        setInData(mappedTableData);
    }, [mappedTableData]);

   
    const statusColor = useMemo(() => {
        if (!leaveData?.status) return '';
        
        switch (leaveData.status) {
            case 'Approved':
                return 'rgb(0, 194, 146)';
            case 'Pending':
                return '#f6b000';
            case 'Rejected':
                return '#D21010';
            default:
                return '';
        }
    }, [leaveData?.status]);


    const getDateRange = useMemo(() => {
        if (!leaveData) return '';
        
        if (!isMultipleLeaves) {
            return moment(leaveData?.leave_date?.split(" ")?.[0] || leaveData?.start_date?.split(" ")?.[0])?.format('DD-MM-YYYY');
        }
        
        const dates = data.map(item => moment(item?.leave_date?.split(" ")?.[0] || item?.start_date?.split(" ")?.[0]));
        const startDate = moment.min(dates);
        const endDate = moment.max(dates);
        
        if (startDate.isSame(endDate, 'day')) {
            return startDate.format('DD-MM-YYYY');
        }
        
        return `${startDate.format('DD-MM-YYYY')} - ${endDate.format('DD-MM-YYYY')}`;
    }, [data, isMultipleLeaves, leaveData]);

  
    const getLeaveType = useMemo(() => {
        if (!leaveData) return '';
        
        if (!Array.isArray(data)) {
            return leaveData?.casual > 0 ? "Casual Leave" : "Unpaid Leave";
        }
        
        const hasCasual = data.some(item => item?.casual > 0);
        const hasUnpaid = data.some(item => item?.unpaid > 0);
        
        if (hasCasual && hasUnpaid) {
            return "Casual/Unpaid Leave";
        }
        return hasCasual ? "Casual Leave" : "Unpaid Leave";
    }, [data, leaveData]);


    const getDuration = useMemo(() => {
        if (!leaveData) return '';
        
        if (!isMultipleLeaves) {
            if (leaveData?.duration?.includes('Half')) {
                return `Half Day - ${leaveData?.duration === 'firstHalf' ? 'First Half' : 'Second Half'}`;
            }
            return "Full Day";
        }
        
        return `Multiple Days (${data.length} leave${data.length > 1 ? 's' : ''})`;
    }, [data, isMultipleLeaves, leaveData]);

   
    const handleChange = (e) => {
        if (e[1] === "headerAll" && e[0] === true) {
            setTotalSelectedIds([...e[2]]);
        } else if (e[0] === true && e[1] !== "headerAll") {
            setTotalSelectedIds([...totalSelectedIds, e[1]]);
        } else if (e[1] === "headerAll" && e[0] === false) {
            setTotalSelectedIds([]);
        } else {
            let filteredId = totalSelectedIds.filter((item) => {
                return item !== e[1];
            });
            setTotalSelectedIds(filteredId);
        }
    };

    
    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
           
                await props.deleteInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
               
                console.log("Export functionality not implemented");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
           
            setExportrLoading(false);
        }
    };


    const applyFilters = ({ status, startDate, endDate }) => {
        setFilteredStartDate(filteredStartDate || startDate);
        setFilteredEndDate(filteredEndDate || endDate);
        const filtered = inData?.filter((leave) => {
            let matchesStatus = true;
            let matchesDate = true;

            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                const itemStartDate = moment(leave?.["Start Date"]?.value).startOf('day');
                const itemEndDate = moment(leave?.["End Date"]?.value).startOf('day');

                const filterStart = moment(filteredStartDate || startDate).startOf('day');
                const filterEnd = moment(filteredEndDate || endDate).endOf('day');

                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemEndDate.isBetween(filterStart, filterEnd, undefined, '[]');
            }
            if (status) {
                matchesStatus = leave?.["Leave Status"]?.value?.toLowerCase() === status?.value?.toLowerCase();
            }
            return matchesStatus && matchesDate;
        });
        setFilteredData(filtered);
    };


    const handleClear = () => {
        setClientData({ projectstatus: null });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    };


    const handleClose = () => {
        setOpenModal(false);
    };


    useEffect(() => {
        setChecked(totalSelectedIds.length > 0);
    }, [totalSelectedIds]);

    if (loading || !data) {
        return (
            <div className="empLeaveView-main">
                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            </div>
        );
    }

    return (
        <div className="empLeaveView-main">
            {/* Header */}
            <div className="page-title">
                <h4>Leave {isMultipleLeaves ? '- Multiple Leaves' : ''}</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => {
                            if (location?.pathname?.includes(`/employees/view/${employeeId}/leave/view/multiple`)) {
                                navigate(`/employees/view/${employeeId}/leave`);
                            } else {
                                navigate('/leave/empleave');
                            }
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
            
            {/* Leave Details Section */}
            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="empleave-detail">
                                    <h5>Leave Details</h5>
                                    <h6 className='empleave-detail-divider'>
                                        Apply Date - {moment(leaveData?.createdAt)?.format('DD-MM-YYYY hh:mm A')}
                                    </h6>
                                    
                                    <div className="row">
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Applicant Name</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="profile-section">
                                                    {leaveData?.user?.profile_pic ? (
                                                        <img 
                                                            src={`data:image/jpeg;base64,${btoa(
                                                                new Uint8Array(leaveData?.user?.profile_pic?.data).reduce(
                                                                    (data, byte) => data + String.fromCharCode(byte),
                                                                    ''
                                                                )
                                                            )}`} 
                                                            alt="Profile Pic" 
                                                            className="profile-pic" 
                                                        />
                                                    ) : (
                                                        <UserAvatar 
                                                            name={leaveData?.user?.name || '--'} 
                                                            size={40} 
                                                            className='profile-pic' 
                                                            color="#5757fe" 
                                                            style={{ textTransform: 'uppercase', color: 'white' }} 
                                                        />
                                                    )}
                                                    <div className="profile-info">
                                                        <h6 className='labels'>{leaveData?.user?.name}</h6>
                                                        <h6 className='labels'>{leaveData?.user?.designation?.name}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Leave Date{isMultipleLeaves ? 's' : ''}</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className='labels'>{getDateRange}</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Leave Type</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="leaveType">
                                                    <div className={`leaveType-background`}>
                                                        <h6 className={`leaveType-text`}>{getLeaveType}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Duration</h6>
                                            </div>
                                            <div className="col-9 duration">
                                                <h6 className='labels'>{getDuration}</h6>
                                            </div>
                                        </div>

                                        {!isMultipleLeaves && (
                                            <div className="input-groups">
                                                <div className="col-3">
                                                    <h6 className='labels'>Reason For Absence</h6>
                                                </div>
                                                <div className="col-9">
                                                    <h6 className='labels'>{leaveData?.reason}</h6>
                                                </div>
                                            </div>
                                        )}

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Status</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="leaveStatus">
                                                    <div
                                                        className={`leaveStatus-circle ${leaveData?.status}`}
                                                        style={{ backgroundColor: statusColor }}
                                                    ></div>
                                                    <h6
                                                        className={`leaveStatus-text ${leaveData?.status}`}
                                                        style={{ color: statusColor }}
                                                    >
                                                        {leaveData?.status}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Table Section for Multiple Leaves */}
                {isMultipleLeaves && (
                    <div className="row mt-4">
                        <div className="col-lg-12">
                            <div className='viewEmployee-main'>
                                {/* Filters and Export Section */}
                                <div className='row mb-3'>
                                    <div className='col-lg-6 col-md-6 col-sm-12'>
                                        <button
                                            className="export-btn"
                                            id="exportBtn"
                                            disabled={!checked || exportLoading}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleClick(totalSelectedIds, "export");
                                            }}
                                        >
                                            {exportLoading ? (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    className="custom-spinner"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                "Export"
                                            )}
                                        </button>

                                        {(clientData?.projectstatus || filteredData?.length > 0 || dateStatus) && (
                                            <button
                                                className="export-btn ms-2"
                                                disabled={props.loading}
                                                onClick={handleClear}
                                            >
                                                {props.loading ? (
                                                    <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                                                ) : (
                                                    'Clear'
                                                )}
                                            </button>
                                        )}
                                    </div>

                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="card-type">
                                            <CustomCalendar
                                                inData={inData}
                                                setFilteredData={setFilteredData}
                                                selectedStatus={clientData?.projectstatus}
                                                applyFilters={(params) => { applyFilters(params) }}
                                                startDate={filteredStartDate}
                                                endDate={filteredEndDate}
                                                setStartDate={setFilteredStartDate}
                                                setEndDate={setFilteredEndDate} />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <label className="labeling">
                                            <Select
                                                options={ProjectStatus}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                        width: '100%',
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        boxShadow: 'none',
                                                        border: '1px solid #ced4da',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#6c757d',
                                                    }),
                                                }}
                                                value={clientData.projectstatus}
                                                placeholder="Status"
                                                onChange={(val) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        projectstatus: val
                                                    }));

                                                    applyFilters({ status: val, startDate: filteredStartDate, endDate: filteredEndDate })
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                                isSearchable
                                                getOptionLabel={(e) => (
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span
                                                            style={{
                                                                height: '12px',
                                                                width: '12px',
                                                                backgroundColor: e.color,
                                                                borderRadius: '50%',
                                                                display: 'inline-block',
                                                                marginRight: '10px',
                                                                marginLeft: '10px'
                                                            }}
                                                        />
                                                        {e.label}
                                                    </div>
                                                )}
                                                getOptionValue={(e) => e.value}
                                            />
                                        </label>
                                    </div>
                                </div>

                                {/* Table */}
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="empleave-detail">
                                        <h5>Individual Leave Details</h5>
                                        <div className="invoice-table-part">
                                            <Table
                                                header={header}
                                                data={(clientData?.projectstatus || dateStatus) ? filteredData : inData}
                                                footer={footer}
                                                count={count}
                                                checked={checked}
                                                records={count}
                                                totalSelectedIds={totalSelectedIds}
                                                defaultParams={params}
                                                selectedId={selectedId}
                                                handleChange={handleChange}
                                                loading={props.loading}
                                                showIsView={false}
                                                updateLeave={props?.updateLeave}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state?.leaveReducer?.loading,
        leave: state?.leaveReducer?.leave,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getLeaves: () => {
            dispatch(getLeaves())
        },
        updateLeave: (id, data) => {
            dispatch(updateLeave(id, data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleLeaveView);